export default __webpack_public_path__ + "static/media/card1.7b431592.png";